/**
 * a collection of enumerators to be used at various places during the project.
 */
const DoneButtonStates = {
  Invisible: 'invisible',
  WaitingForInput: 'waitingForInput',
  Correct: 'correct',
  Incorrect: 'incorrect',
};

const SentenceZoneBorders = {
  None: 'none',
  DottedPurple: 'dottedPurple',
  SolidGreen: 'solidGreen',
  SolidRed: 'solidRed',
};

const WordGrammarPositions = {
  FirstWord: 'first',
  MiddleWord: 'middle',
  LastWord: 'last',
};

const SentenceTypes = {
  question: 'question',
  statement: 'statement',
};

export {
  DoneButtonStates,
  SentenceZoneBorders,
  WordGrammarPositions,
  SentenceTypes,
};
